import styled from "styled-components"

export const FieldContainer =  styled.div `
    
    width: 100%;
    height: fit-content;
    display: grid;
    grid-auto-flow: column;

`